import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Shield } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const AdminLogin = () => {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (user) nav("/admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Makeba!");
      nav("/admin");
    } catch (err) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-[70vh] flex items-center justify-center px-5 py-12">
      <form onSubmit={submit} className="brutal-lg bg-white rounded-3xl p-8 w-full max-w-md">
        <div className="w-14 h-14 bg-[#000000] text-[#F3E30A] rounded-2xl flex items-center justify-center mb-4">
          <Shield />
        </div>
        <h1 className="font-display font-black text-3xl text-[#000000]">Admin Login</h1>
        <p className="text-sm text-[#333333] mt-1">For Makeba Design &amp; Prints staff.</p>

        <div className="mt-6 space-y-3">
          <input
            data-testid="admin-email"
            type="email"
            required
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 border-2 border-[#000000] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#EC008C]"
          />
          <input
            data-testid="admin-password"
            type="password"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 border-2 border-[#000000] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#EC008C]"
          />
        </div>

        <button
          data-testid="admin-login-btn"
          disabled={loading}
          className="mt-5 w-full bg-[#EC008C] text-[#FFFFFF] font-display font-bold py-3 rounded-full brutal flex items-center justify-center gap-2 disabled:opacity-60"
        >
          {loading ? <Loader2 size={18} className="animate-spin" /> : "Sign in"}
        </button>
      </form>
    </main>
  );
};

export default AdminLogin;
